( function( $ ) {
    'use strict';
	var $tabTrigger;
	var $tabBody;
	var activeClass = 'is-active';

    function registerClickHandler() {
	    $tabTrigger.on( 'click', function( event ) {
		    var tabTarget = $( this ).attr( 'data-tab' );
		    event.preventDefault();
		    $tabTrigger.add( $tabBody ).removeClass( activeClass ).filter( '[data-tab="' + tabTarget + '"]').addClass( activeClass );
	    } );
    }

    $( function() {
	    $tabTrigger = $( '.js-tab-trigger' );
	    $tabBody = $( '.js-tab-body' );

	    if ( $tabTrigger.length ) {
	    	registerClickHandler()
	    }
    } );
} )( jQuery );
